export class RoleData {
  constructor(
    isAdmin: boolean,
    isCustomer: boolean,
    isMerchant: boolean,
    merchantIds: number[] = [],
    isThirdParty?: boolean,
    thirdPartyType?: number
  ) {
    this.admin = isAdmin;
    this.customer = isCustomer;
    this.merchant = isMerchant;
    this.merchantPermissions = merchantIds;
    this.isThirdParty = isThirdParty;
    this.thirdPartyType = thirdPartyType;
  }

  admin? = false;
  customer? = false;
  merchant? = false;
  paymentIntegration? = false;
  giftCardIntegration? = false;
  merchantPermissions: number[] = [];
  roleId: string;
  isThirdParty? = false;
  thirdPartyType?: number;
}
